if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.handlerRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const action = event.target.closest('a')?.getAttribute('data-action') || event.target.getAttribute('data-action');
      if (!action) return;
      const key = this.getAttribute('data-key');
      const quantity = Number(this.getAttribute('data-quantity'));
      const updates = {};
      updates[key] = quantity + Number(action);

      if (updates[key] == 0 && this.getAttribute('data-addons-to-remove')) {
        const addonsList = this.getAttribute('data-addons-to-remove')
          .split('|')
          .filter((value) => value != '');

        addonsList.forEach(addon => {
          updates[addon] = 0;
        })
      }

      let updateType = 'mini-cart-item-quantity-add';
      if(Number(action) < 0){
        updateType = 'mini-cart-item-quantity-remove';
      }

      updateQuantity({ updates },updateType);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handlerRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handlerRef);
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
